import { useNavigate } from 'react-router'
import { useAuthStore } from '@/store/authStore'
import { authApi } from '@/services/auth/authApi'

export const useLogout = () => {
  const clearAuth = useAuthStore((state) => state.clearAuth)
  const navigate = useNavigate()

  const logout = async () => {
    const authProvider = localStorage.getItem('auth_provider')
    const accessToken = localStorage.getItem('token')

    // 1. Clear localStorage immediately (instant UX)
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('user')
    localStorage.removeItem('auth_provider')

    // Clear session storage for OAuth state
    sessionStorage.removeItem('oauth_state')
    sessionStorage.removeItem('pkce_code_verifier')

    // 2. Reset Zustand state
    clearAuth()

    // 3. Redirect to login immediately
    navigate('/login')

    // 4. Background: Call backend to revoke Google token (fire & forget)
    if (authProvider === 'google' && accessToken) {
      authApi.logoutGoogle(accessToken).catch(() => {
        // Silently fail - user already logged out locally
      })
    }
  }

  return {
    mutate: logout,
    isPending: false,
  }
}
